/* dev-offer-price.js
 * Discount-link offer outside the product page: product cards, Quick Shop and the
 * cart's "You May Also Like" render the offer price hidden next to the regular one.
 * For visitors whose session carries the offer code (they arrived via /discount/<code>)
 * this swaps them: [data-offer="alt"] shows, [data-offer="regular"] hides, and options
 * with data-offer-price take it as their data-price. Checkout is untouched — the real
 * Shopify discount does the charging.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  var offerCode = ((script && script.dataset.offerCode) || '').trim().toLowerCase();
  if (!offerCode) return;

  // "Ends on" (YYYY-MM-DD): the code outlives the discount in the visitor's cookie.
  var ends = ((script && script.dataset.offerEnds) || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (ends && new Date() >= new Date(+ends[1], +ends[2] - 1, +ends[3] + 1)) return;

  function cookieCode() {
    var match = document.cookie.split('; ').find(function (c) {
      return c.indexOf('discount_code=') === 0;
    });
    return match ? decodeURIComponent(match.slice('discount_code='.length)) : '';
  }

  function hasCode() {
    if (cookieCode().trim().toLowerCase() === offerCode) return Promise.resolve(true);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).some(function (d) {
          return (d.code || '').trim().toLowerCase() === offerCode;
        });
      })
      .catch(function () { return false; });
  }

  function apply(root) {
    root.querySelectorAll('[data-offer-price]').forEach(function (option) {
      option.dataset.price = option.dataset.offerPrice;
      if (option.dataset.offerSave !== undefined) option.dataset.save = option.dataset.offerSave;
    });
    root.querySelectorAll('[data-offer]').forEach(function (el) {
      el.hidden = el.dataset.offer !== 'alt';
    });
  }

  function start() {
    hasCode().then(function (active) {
      if (!active) return;
      apply(document);
      // The cart drawer and other sections re-render from the server; keep new markup in step.
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) apply(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
